import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-32 border-t border-border bg-forest text-white">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-8 h-8 bg-safety text-white grid place-items-center font-display font-black text-lg">FX</div>
            <div className="font-display font-black text-xl tracking-tight">Furniture Exchange</div>
          </div>
          <p className="text-sm text-white/70 max-w-md leading-relaxed">
            The UK marketplace connecting offices, buyers and commercial removal companies —
            for buying, selling and clearing quality workplace furniture with zero landfill.
          </p>
        </div>
        <div>
          <div className="overline text-white/60 mb-4">Marketplace</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/listings" className="hover:text-safety transition-colors duration-200">Browse listings</Link></li>
            <li><Link to="/sell" className="hover:text-safety transition-colors duration-200">Post a listing</Link></li>
            <li><Link to="/listings?clearance=true" className="hover:text-safety transition-colors duration-200">Clearance sales</Link></li>
            <li><Link to="/removal-companies" className="hover:text-safety transition-colors duration-200">Find a mover</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline text-white/60 mb-4">Company</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/about" className="hover:text-safety transition-colors duration-200">About us</Link></li>
            <li><a href="mailto:info@furnitureexchange.co.uk" className="hover:text-safety transition-colors duration-200">info@furnitureexchange.co.uk</a></li>
            <li><a href="mailto:accounts@furnitureexchange.co.uk" className="hover:text-safety transition-colors duration-200">Billing enquiries</a></li>
            <li><Link to="/dashboard/verification" className="hover:text-safety transition-colors duration-200">Get verified ✓</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-6 lg:px-10 py-6 flex items-center justify-between text-xs text-white/50">
          <div className="flex items-center gap-4">© {new Date().getFullYear()} Furniture Exchange Ltd. · <Link to="/terms" className="hover:text-safety underline">Terms</Link> · <Link to="/privacy" className="hover:text-safety underline">Privacy</Link> · <Link to="/cookies" className="hover:text-safety underline">Cookies</Link></div>
          <div className="overline">Built in the UK</div>
        </div>
              <div className="overline">Developed by Slawomir Slemp</div>
      </div>
    </footer>
  );
}
